import { useReducer } from 'react'

// Reducer states
const idleStatus = 'idleStatus'
const loadingStatus = 'loadingStatus'
const errorStatus = 'errorStatus'
const finishedStatus = 'finishedStatus'

// Reduce actions
const startFetchAction = 'startFetchAction'
const fetchSuccessAction = 'fetchSuccessAction'
const fetchErrorAction = 'fetchErrorAction'
const reachedEndAction = 'reachedEndAction'

export function infiniteScrollReducer(state, action) {
  switch (state.status) {
    case idleStatus:
    case errorStatus:
      return action.type === startFetchAction ? { ...state, status: loadingStatus } : state
    case loadingStatus:
      switch (action.type) {
        case fetchSuccessAction:
          return {
            ...state,
            status: idleStatus,
            changes: [...state.changes, ...action.payload.changes],
            idsMetadata: { ...state.idsMetadata, ...action.payload.idsMetadata },
            hasMoreData: action.payload.hasMoreData,
            nextPageToken: action.payload.nextPageToken,
          }
        case fetchErrorAction:
          return { ...state, status: errorStatus }
        case reachedEndAction:
          return {
            ...state,
            status: finishedStatus,
            changes: [...state.changes, ...action.payload.changes],
            idsMetadata: { ...action.payload.idsMetadata },
            hasMoreData: false,
            nextPageToken: action.payload.nextPageToken,
          }
        default:
          return state
      }
    case finishedStatus:
      return state

    default:
      throw new Error(`InfiniteScrollChange error status:${state.status} - action:${action.type}`)
  }
}

export default function useRelationshipChangesState(relationshipId, relationshipType) {
  const initialState = {
    status: loadingStatus,
    hasMoreData: false,
    nextPageToken: '',
    changes: [],
    idsMetadata: [],
    relationshipId,
    relationshipType,
  }

  const [state, dispatch] = useReducer(infiniteScrollReducer, initialState)

  return { state, dispatch }
}
